import React, { useState } from 'react';
import { Card, Text, ScrollArea, Accordion, Badge, Group, Stack, Flex } from '@mantine/core';
import { statusConfig } from '../utils/taskConfig';
import { filterBreachesByStatus, groupBreachesByStatus } from '../utils/taskHelpers';
import BreachRecordDetailModal from './BreachRecordDetailModal';

const normalizeStr = s => (s || '').normalize('NFD').replace(/\p{Mn}/gu, '').toLowerCase();

const getImpactoBadgeColor = label => {
    const l = (label || '').toLowerCase();
    if (l.includes('alto')) return 'red';
    if (l.includes('medio')) return 'yellow';
    if (l.includes('bajo')) return 'teal';
    return 'gray';
};

const TaskAccordion = ({ 
    breachData = [],
    filterType = 'all', 
    selectedDate = null,
    onRefresh,
}) => {

    const [selectedBreach, setSelectedBreach] = useState(null);
    const [modalOpened, setModalOpened] = useState(false);

    const handleBreachClick = (breach) => {
        setSelectedBreach(breach);
        setModalOpened(true);
    };

    const handleCloseModal = () => {
        setModalOpened(false);
        setSelectedBreach(null);
    };

    const handleSave = () => {
        handleCloseModal();
        onRefresh?.();
    };

    const filteredBreaches = filterBreachesByStatus(breachData, filterType);
    const groupedBreaches = groupBreachesByStatus(filteredBreaches);

    const statusOrder = ['Pendiente', 'Expirado', 'En revisión', 'Aprobado', 'Rechazado'];

    return (
        <Card withBorder radius="lg" style={{ height: '100%' }}>
            <Card.Section inheritPadding py="md">
                <Text size="sm" fw={600} c="dimmed">
                    Actividades - {filteredBreaches.length} encontrados
                </Text>
            </Card.Section>
            <Card.Section>
                <ScrollArea style={{ height: 'calc(80vh - 200px)' }}>
                    {filteredBreaches.length === 0 ? (
                        <Text size="sm" c="gray.6" ta="center" py="xl">
                            No hay Actividades para los filtros seleccionados
                        </Text>
                    ) : (
                        <Accordion multiple chevronPosition="left">
                            {statusOrder
                                .filter(status => groupedBreaches[status])
                                .map((statusName) => {
                                    const breachesInGroup = groupedBreaches[statusName];
                                    const config = statusConfig[statusName] || {};

                                    return (
                                        <Accordion.Item key={statusName} value={statusName}>
                                            <Accordion.Control>
                                                <Group gap="md" justify="space-between" style={{ width: '100%' }}>
                                                    <Flex style={{gap:'5px'}} align="center">
                                                        <Text c={config.color || 'gray'} style={{ lineHeight: 1 }}>
                                                            <i className={config.iconClass || 'icon-circle'}></i>
                                                        </Text>
                                                        <Text size="sm" fw={600}>{config.label || statusName}</Text>
                                                        <Text size="xs" c="dimmed"> • {breachesInGroup.length}</Text>
                                                    </Flex>
                                                </Group>
                                            </Accordion.Control>
                                            <Accordion.Panel>
                                                <Stack gap="xs">
                                                    {breachesInGroup.map((breach) => (
                                                        <Card 
                                                            key={breach._id} 
                                                            padding="sm"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => handleBreachClick(breach)}
                                                            withBorder
                                                        >
                                                            <Group justify="space-between" style={{ width: '100%' }}>
                                                                <Group gap="sm" style={{ flex: 1, minWidth: 0 }}>
                                                                    <Badge 
                                                                        size="sm" 
                                                                        variant="light"
                                                                        color={config.color || 'gray'}
                                                                        style={{ flexShrink: 0 }}
                                                                        radius="sm"
                                                                    >
                                                                        <i className={config.iconClass || 'icon-circle'}></i>
                                                                    </Badge>
                                                                    <Flex direction={'column'} style={{ flex: 1, minWidth: 0, gap: '5px' }}>
                                                                        <Text size="sm" fw={500} style={{ wordBreak: 'break-word' }}>
                                                                            {breach.description || 'Sin descripción'}
                                                                        </Text>
                                                                        <Group style={{justifyContent: 'space-between'}}>
                                                                            {breach.breach_category?.name && (
                                                                                <Badge size="xs" variant="light" color="blue" tt={'capitalize'}>
                                                                                    {breach.breach_category.name}
                                                                                </Badge>
                                                                            )}
                                                                            {breach.breach_impact?.name && (
                                                                                <Badge size="xs" variant="light" color={getImpactoBadgeColor(breach.breach_impact.name)} tt={'capitalize'}>
                                                                                    {breach.breach_impact.name}
                                                                                </Badge>
                                                                            )}
                                                                        </Group>
                                                                        <Text size="xs" c="gray.6">
                                                                            {breach.breach_date
                                                                                ? new Date(breach.breach_date).toLocaleDateString('es-CL')
                                                                                : 'Sin fecha'}
                                                                        </Text>
                                                                    </Flex>
                                                                </Group>
                                                            </Group>
                                                        </Card>
                                                    ))}
                                                </Stack>
                                            </Accordion.Panel>
                                        </Accordion.Item>
                                    );
                                })}
                        </Accordion>
                    )}
                </ScrollArea>
            </Card.Section>

            <BreachRecordDetailModal 
                opened={modalOpened}
                onClose={handleCloseModal}
                breach={selectedBreach}
                onSave={handleSave}
            />
        </Card>
    );
};

export default TaskAccordion;
